import React from 'react';
import { originalStatus } from 'features/costing/utils';

import { changeDateFormat, getActionDoneBy, getCostingActivityStatus } from '@utils/Util';

import CommonImage from '@/components/CommonImage';

const CostingTimeline = ({ requiredDate, activityList, onCloseTimeline }) => {
	return (
		<div className="design-timeline-container">
			<div className="design-timeline-header mb-4 d-flex justify-content-between">
				<div>
					<p className="semibold-16 mb-0">Costing Timeline</p>
					<p className="regular-14 gray_dark_02">
						Required: {changeDateFormat(requiredDate, '', 'Do MMM')}
					</p>
				</div>
				<button className="button text-only" onClick={onCloseTimeline}>
					<CommonImage src="/icons/close.svg" alt="close" />
				</button>
			</div>
			<ul className="design-timeline design-timeline-centered">
				{activityList?.map((item) => (
					<li
						className={`design-timeline-item status ${
							item?.completeStatus === 'COMPLETED' || item?.status === 'ARCHIVE'
								? getCostingActivityStatus(item?.status, 'TIMELINE_STATUS')
								: ''
						}`}
						key={item?.status}
					>
						<div className="design-timeline-marker" />
						<div className="design-timeline-content">
							<p className="regular-14">
								{(['APPROVED', 'REJECTED'].includes(item?.status) ? 'Costing ' : '') +
									originalStatus[item?.status] +
									getActionDoneBy(item?.userType || null)}
							</p>
							<span className="regular-12 gray_dark_03">
								{changeDateFormat(item?.dateTime, '', 'Do MMM')}
							</span>
						</div>
					</li>
				))}
			</ul>
		</div>
	);
};

export default CostingTimeline;
